<template>
  <div class="eventClass">
    <div
      class="py-4 white titleBar"
      id="titleBar"
      :style="{ visibility: showTitleBanner ? 'visible' : 'hidden' }"
    >
      <CustomRow>
        <div class="text-small">
          <v-icon color="black" class="mr-1" dense>mdi-domain</v-icon>
          <template v-for="(host, i) in campaign.hosts">
            {{ host }}
            <span
              :key="`host-${i}`"
              class="grey--text"
              v-if="i !== campaign.hosts.length - 1"
              >、</span
            >
          </template>
        </div>
        <h4
          v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
          class="mb-4"
        >
          {{ campaign.title }}
          <v-spacer />
        </h4>
        <h1 v-else class="mt-0 mb-4">
          {{ campaign.title }}
          <v-spacer />
        </h1>
      </CustomRow>
    </div>
    <div class="white">
      <CustomRow>
        <v-row class="pt-6" id="banner">
          <v-col cols="12">
            <div class="image">
              <img :src="`${campaign.picBigActiveMain}`" />
            </div>
          </v-col>
          <v-col cols="12" class="pb-6">
            <div class="tag">
              <template v-for="tag in campaign.tags"> #{{ tag }} </template>
            </div>

            <div class="mb-0 mt-3 text-small domain">
              <v-icon color="black" class="mr-1" dense>mdi-domain</v-icon>
              <template v-for="(host, i) in campaign.hosts">
                {{ host }}
                <span
                  :key="`hosts-${i}`"
                  class="grey--text"
                  v-if="i !== campaign.hosts.length - 1"
                  >、</span
                >
              </template>
            </div>
            <h1
              class="mt-1 mb-4 text-xs-page-title text-sm-massive-title is-word-break"
            >
              {{ campaign.title }}
            </h1>
            <template v-if="!!campaign.announcement">
              <v-divider class="mb-5 mt-4" />
              <div class="py-3 px-5 bg-tranparent-yellow rounded wordBreakAll">
                <h5>{{ $t("activity_announcement") }}</h5>
                <div v-html="campaign.announcement"></div>
              </div>
            </template>
          </v-col>
        </v-row>
      </CustomRow>
    </div>
    <div
      class="white campainTabs"
      :style="{ top: `${appBarHeight + titleBarHeight}px` }"
      id="campainTabs"
    >
      <CustomRow class="px-0 px-md-3">
        <v-tabs v-model="tabSelect" color="primary-1" grow show-arrows>
          <v-tab
            v-for="(tab, tabsIndex) in tabs"
            @click="scrollTo(tab.type, tab)"
            :key="`activity-tab-${tabsIndex}`"
          >
            {{ tab.title }}
          </v-tab>
        </v-tabs>
      </CustomRow>
    </div>

    <CustomRow>
      <CustomCard id="buyTicket" v-if="sessions.length">
        <template v-slot:title>
          <h4 class="mb-3">
            {{
              $t(`activity_buy_ticket${campaign.isLottery ? "_lottery" : ""}`)
            }}
          </h4>
        </template>
        <!-- 電腦版 - table -->
        <!-- <template v-else> -->
        <template v-if="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs">
          <v-divider class="ma-0 mt-2" />
          <v-row class="pa-4 font-weight-bold" no-gutters>
            <v-col cols="10">
              <v-row no-gutters>
                <v-col cols="4" class="is-word-break">{{
                  $t("activity_session_name")
                }}</v-col>
                <v-col cols="2">{{ $t("activity_session_date") }}</v-col>
                <v-col cols="2">{{ $t("activity_session_time") }}</v-col>
                <v-col cols="4" class="is-word-break">{{
                  $t("activity_session_location")
                }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="2">{{
              $t(
                `activity_session_status${campaign.isLottery ? "_lottery" : ""}`
              )
            }}</v-col>
          </v-row>
          <v-divider class="ma-0" />
        </template>

        <div v-for="(session, i) in sessions" :key="i" class="sesstion-item">
          <v-row class="pa-4 flex-column flex-sm-row" no-gutters>
            <v-col
              cols="12"
              sm="10"
              md="10"
              :class="{
                'text-small': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
              }"
            >
              <v-row class="mx-0 flex-column flex-md-row" no-gutters>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  class="d-flex text-left font-weight-bold text-regular py-2 is-word-break"
                  :align-self="
                    $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                      ? 'left'
                      : 'center'
                  "
                >
                  {{ session.name }}
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="px-md-2 d-flex justify-md-center align-left align-md-center"
                >
                  <div class="d-flex mb-2 mb-md-0">
                    <div
                      class="grey--text text--darken-1 d-block d-md-none mr-2 wordBreakKeepAll"
                    >
                      {{ $t("activity_mobile_session_date") }}
                    </div>
                    <div v-html="dateDisplay(session.date)"></div>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="px-md-2 d-flex justify-md-center align-md-center"
                >
                  <div class="d-flex mb-2 mb-md-0">
                    <div
                      class="grey--text text--darken-1 d-block d-md-none mr-2 wordBreakKeepAll"
                    >
                      {{ $t("activity_mobile_session_time") }}
                    </div>
                    <div>{{ timeDisplay(session.time) }}</div>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  class="px-md-2 d-flex justify-md-center align-md-center is-word-break"
                >
                  <div class="d-flex mb-2 mb-md-0">
                    <div
                      class="grey--text text--darken-1 d-block d-md-none mr-2 wordBreakKeepAll"
                    >
                      {{ $t("activity_mobile_session_location") }}
                    </div>
                    <div class="text-left text-md-center location-content">
                      {{ session.location }}
                      <div
                        v-if="session.address"
                        class="grey--text text--darken-3 text-small d-inline d-md-block"
                      >
                        {{ session.address }}
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
              align-self="center"
              class="font-weight-bold"
            >
              <v-divider class="d-block d-sm-none mb-5 mt-3" />
              <SessionTable
                :eventId="campaign.event_id"
                :session="session"
                @emitGetSessionStatus="getInfo"
              />
            </v-col>
          </v-row>
          <div
            v-if="i + 1 !== sessions.length"
            class="red-dash-divider d-none d-sm-block"
          />
        </div>
        <!-- </template> -->
      </CustomCard>
      <CustomCard id="activityInfo" v-if="campaign.info">
        <template v-slot:title>
          <h4>{{ $t("activity_intro") }}</h4>
        </template>
        <div class="campaign-content-frame">
          <!-- <iframe
            src="https://www.youtube-nocookie.com/embed/mUF5ZIehenU"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe> -->
          <div v-html="campaign.info" class="text-left"></div>
        </div>
      </CustomCard>
      <CustomCard id="notice" v-if="campaign.notice">
        <template v-slot:title>
          <h4>
            {{ $t(`activity_notice${campaign.isLottery ? "_lottery" : ""}`) }}
          </h4>
        </template>
        <div
          v-html="campaign.notice"
          class="campaign-content-frame text-left"
        ></div>
      </CustomCard>
      <CustomCard id="remind" v-if="campaign.buy_notice">
        <template v-slot:title>
          <h4>
            {{
              $t(`activity_buy_notice${campaign.isLottery ? "_lottery" : ""}`)
            }}
          </h4>
        </template>
        <div
          v-html="campaign.buy_notice"
          class="campaign-content-frame text-left"
        ></div>
      </CustomCard>
      <CustomCard id="getInfo" v-if="campaign.get_notice">
        <template v-slot:title>
          <h4>{{ $t("activity_get_notice") }}</h4>
        </template>
        <div
          v-html="campaign.get_notice"
          class="campaign-content-frame text-left"
        ></div>
      </CustomCard>
      <CustomCard id="refundInfo" v-if="campaign.refund_info">
        <template v-slot:title>
          <h4>{{ $t("activity_refund_info") }}</h4>
        </template>
        <div
          v-html="campaign.refund_info"
          class="campaign-content-frame text-left"
        ></div>
      </CustomCard>
    </CustomRow>

    <template v-if="campaign.isAdvertised && campaign.advertisement">
      <v-overlay :opacity="0.6" v-model="adModal.show" z-index="6">
        <v-dialog
          v-model="adModal.show"
          :width="475"
          :height="$vuetify.breakpoint.xs ? 400 : 533"
          :persistent="false"
          hide-overlay
        >
          <v-card class="text-center pa-5">
            <h2 class="mb-4">{{ adTitle }}</h2>
            <a :href="campaign.advertisement.href" target="_blank">
              <v-img
                :src="campaign.advertisement.img"
                :height="$vuetify.breakpoint.xs ? 302 : 435"
              />
            </a>
          </v-card>
          <v-btn
            icon
            @click="adModal.show = false"
            fab
            depressed
            small
            class="primary-1 float-btn"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-dialog>
      </v-overlay>
    </template>
  </div>
</template>

<script>
import SessionTable from "@/views/components/SessionTable";
import { getEvent, getSessions } from "@/api/static";
import { mapActions } from "vuex";
import CC from "@/api/config-center";
import dayjs from "dayjs";
import { decrypt } from "../vendor/crypto";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone"; // dependent on utc plugin

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Taipei");

export default {
  components: { SessionTable },
  data() {
    const dt = new Date();
    const timeString = `${dt.getFullYear()}/${
      dt.getMonth() + 1
    }/${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}`;
    return {
      campaign: {},
      adModal: { show: true },
      tabSelect: null,
      sessions: [
        {
          address: "Loading...",
          areaAssignment: undefined,
          date: "2024-05-20 ~ 2024-12-31",
          eventId: "2f6431aac30afb722f615b9b95aabb0e",
          exposeEnd: "2030-12-31T23:59:00+08:00",
          exposeStart: "2024-05-20T10:00:00+08:00",
          hidden: false,
          loadingStatusFinished: true,
          location: "Loading...",
          name: "Loading...",
          picBigArea: "",
          picSmallArea: "",
          sessionId: "c18900a1d5f295218fe60b982d7ece96",
          sortedIndex: 1,
          status: "onsale",
          ticketArea: true,
          time: "19:00 ~ 23:59",
        },
      ],
      showTitleBanner: false,
      titleBarHeight: 0,
      appBarHeight:
        this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm ? 48 : 64,
      reloadCount: 0,
      clickGoTo: false,
      isLottery: false,
    };
  },
  watch: {
    campaign: {
      deep: true,
      handler(newVal) {
        if (newVal.title) {
          this.$nextTick(() => {
            this.titleBarHeight =
              document.getElementById("titleBar").clientHeight;
          });
        }
      },
    },
  },
  metaInfo() {
    return {
      title: `${this.campaign.title || ""} - ${this.$t("app_name")}`,
      meta: [
        {
          property: "og:title",
          content: `${this.campaign.title || ""} - ${this.$t("app_name")}`,
          vmid: "og:title",
        },
        {
          property: "og:url",
          content: window.location.origin + window.location.pathname,
          vmid: "og:url",
        },
        {
          property: "og:img",
          content: this.campaign.picSmallActiveMain,
          vmid: "og:img",
        },
        {
          property: "og:image",
          content: this.campaign.picSmallActiveMain,
          vmid: "og:image",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: window.location.origin + window.location.pathname,
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: `${this.campaign.title || ""} - ${this.$t("app_name")}`,
            url: window.location.origin + window.location.pathname,
          },
        },
      ],
    };
  },
  computed: {
    campaignDate() {
      const start = this.campaign.start_date;
      const end = this.campaign.end_date;

      return start === end ? start : `${start} ~ ${end}`;
    },
    campaignTime() {
      if (!this.campaign.time) {
        return "";
      } else {
        if (this.campaign.time.indexOf("~") > -1) {
          const dt = this.campaign.time.split(" ~ ");
          return dt[0] === dt[1] ? dt[0] : `${dt[0]} ~ ${dt[1]}`;
        } else {
          return this.campaign.time;
        }
      }
    },
    tabs() {
      let tabList = [];
      if (this.sessions.length)
        tabList.push({
          title: this.$t(
            `activity_buy_ticket${this.campaign.isLottery ? "_lottery" : ""}`
          ),
          type: "buyTicket",
        });
      if (this.campaign.info)
        tabList.push({
          title: this.$t("activity_intro"),
          type: "activityInfo",
        });
      if (this.campaign.notice)
        tabList.push({
          title: this.$t(
            `activity_notice${this.campaign.isLottery ? "_lottery" : ""}`
          ),
          type: "notice",
        });
      if (this.campaign.buy_notice)
        tabList.push({
          title: this.$t(
            `activity_buy_notice${this.campaign.isLottery ? "_lottery" : ""}`
          ),
          type: "remind",
        });
      if (this.campaign.get_notice)
        tabList.push({
          title: this.$t("activity_get_notice"),
          type: "getInfo",
        });
      if (this.campaign.refund_info)
        tabList.push({
          title: this.$t("activity_refund_info"),
          type: "refundInfo",
        });
      return tabList;
    },
    adTitle() {
      return this.campaign.isAdvertised
        ? this.campaign.advertisement.title[this.$store.getters.locale]
        : null;
    },
    warningText() {
      if (this.campaign.hasWarning) {
        return this.campaign.warningText[this.$store.getters.locale];
      } else return null;
    },
    targetPosition() {
      let targetPositionList = [];
      let subHeight =
        document.getElementById("campainTabs").clientHeight +
        this.titleBarHeight +
        16;
      this.tabs.forEach((t) => {
        targetPositionList.push(
          document.getElementById(t.type).offsetTop - subHeight
        );
      });
      return targetPositionList;
    },
  },
  created() {
    this.$store.dispatch("setOverlayLoading", true);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
  },
  async mounted() {
    const { data } = await getEvent(this.$route.params.id);
    if (data.errCode === "102") window.location.href = "/";
    this.campaign = { ...data, isLottery: !!data.lotteryDeadline };
    const { data: sessionsData } = await getSessions(this.campaign.event_id);
    this.sessions = sessionsData.sessions.map((s) => {
      s.loadingStatusFinished = false;
      return s;
    });
    await this.getInfo();

    // this.handleScroll();
    this.$gtm.trackView(`Activity：${this.campaign.title}`, this.$route.path);
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      setCampaign: "event/setCampaign",
    }),
    async getInfo() {
      let req = {
        eventId: [this.$route.params.id],
      };
      if (this.sessions.length)
        req.sessionId = this.sessions.map((s) => s.sessionId);
      const [{ data: info }, getInfosErr] = await CC.getInfos(req);

      if (getInfosErr) {
        this.sessions = this.sessions.map((s) => ({
          ...s,
          canLoadingAgain: true,
        }));
        this.reloadCount++;
        this.getInfo();
      } else {
        if (info.result?.session && !info.result.session[0].status) {
          if (this.reloadCount < 3) {
            this.sessions = this.sessions.map((s) => ({
              ...s,
              canLoadingAgain: true,
            }));
            this.reloadCount++;
            this.getInfo();
          } else {
            this.showDialog({
              alert: true,
              title: this.$t("activity_busy_title"),
              content: this.$t("activity_busy_content"),
            });
          }
        } else {
          await this.setEvent(info.result.event[0]);
          if (info.result?.session) await this.setSession(info.result.session);
        }
        this.appBarHeight =
          this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm ? 48 : 64;
        this.showTitleBanner = false;

        this.$store.dispatch("setOverlayLoading", false);
      }
    },
    setEvent(event) {
      this.campaign = { ...this.campaign, ...event };
      this.setCampaign({
        ...this.campaign,
      });

      if (this.campaign.isAdvertised) {
        this.adModal = {
          show: true,
        };
      }

      if (this.campaign.hasWarning) {
        this.showDialog({
          title: this.warningText.title,
          content: this.warningText.content,
          buttons: [
            {
              text: this.$t("back_to_index"),
              style: {
                block: true,
                outlined: true,
                color: "primary",
              },
              action: async () => {
                this.$router.push({ name: "Index" });
              },
            },
            {
              text: this.$t("layout_notification_confirm"),
              style: {
                block: true,
                outlined: false,
                color: "primary",
              },
              action: () => {},
            },
          ],
        });
      }
    },
    setSession(sessions) {
      this.sessions = this.sessions.reduce((accr, s) => {
        const sid = !/^s[0-9]{9}$/.test(s.sessionId)
          ? decrypt(s.sessionId)
          : s.sessionId;
        // debugger;
        const resSession = sessions.find(
          (res_s) =>
            (!/^s[0-9]{9}$/.test(res_s.id) ? decrypt(res_s.id) : res_s.id) ===
            sid
        );

        accr.push({
          ...s,
          loadingStatusFinished: true,
          sortedIndex: resSession.sortedIndex || 999,
          status: resSession.status,
          areaAssignment: resSession.areaAssignment,
        });
        return accr;
      }, []);
      if (this.sessions.length && !!this.sessions[0].sortedIndex) {
        this.sessions.sort((a, b) => a.sortedIndex - b.sortedIndex);
      }
    },
    timeDisplay(timeString) {
      const ts =
        timeString.indexOf(" ~ ") > -1 ? timeString.split(" ~ ") : timeString;
      if (Array.isArray(ts) && ts[0] !== ts[1]) {
        return timeString;
      } else {
        return Array.isArray(ts) ? ts[0] : timeString;
      }
    },
    dateDisplay(dateString) {
      const days = [
        this.$t("activity_sunday"),
        this.$t("activity_monday"),
        this.$t("activity_tuesday"),
        this.$t("activity_wensday"),
        this.$t("activity_thursday"),
        this.$t("activity_friday"),
        this.$t("activity_saturday"),
      ];

      const ds =
        dateString.indexOf(" ~ ") > -1 ? dateString.split(" ~ ") : dateString;
      new Date().toLocaleString("zh-TW", { timeZone: "Asia/Taipei" });
      if (Array.isArray(ds) && ds[0] !== ds[1]) {
        return !this.$vuetify.breakpoint.xs && !this.$vuetify.breakpoint.sm
          ? `<div>${ds[0]}(${days[dayjs(ds[0]).day()]})</div> ~ <div>${ds[1]}(${
              days[dayjs(ds[1]).day()]
            })</div>`
          : `${ds[0]}(${days[dayjs(ds[0]).day()]}) ~ ${ds[1]}(${
              days[dayjs(ds[1]).day()]
            })`;
      } else {
        const str = Array.isArray(ds) ? ds[0] : dateString;
        return `${str}(${days[dayjs(str).day()]})`;
      }
    },
    handleResize() {
      setTimeout(() => {
        this.titleBarHeight = document.getElementById("titleBar").clientHeight;
        let curr_offset = window.scrollY.toFixed(0);

        // show titlebanner
        if (
          curr_offset >
          document.getElementById("banner").clientHeight - this.titleBarHeight
        ) {
          this.showTitleBanner = true;
        } else {
          this.showTitleBanner = false;
        }
      }, 1000);
    },
    handleScroll() {
      // 處理滾動
      let curr_offset = window.scrollY.toFixed(0);

      // show titlebanner
      if (
        curr_offset >
        document.getElementById("banner").clientHeight - this.titleBarHeight
      ) {
        this.showTitleBanner = true;
      } else {
        this.showTitleBanner = false;
      }

      // prevent switch tabs by window scroll when clicking tab
      if (!this.clickGoTo) {
        let idx = this.targetPosition.findIndex((p) => curr_offset < p);
        this.tabSelect = idx === -1 ? this.targetPosition.length - 1 : idx;
      }
    },
    scrollTo(target, tab) {
      this.clickGoTo = true;
      let tHeight =
        document.getElementById(target).offsetTop -
        document.getElementById("campainTabs").clientHeight -
        this.titleBarHeight -
        16;

      this.$vuetify.goTo(tHeight + this.appBarHeight, { duration: 300 });
      // 活動_${代入活動名稱}_${tab.title}tab
      this.$gtm.trackView(
        `Activity：${this.campaign.title}_${tab.title}`,
        this.$route.path
      );

      setTimeout(() => {
        this.clickGoTo = false;
      }, 350);
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
// ::v-deep .v-slide-group__prev {
//   display: none !important;
// }

.image {
  position: relative;
  width: 100%;
  border-radius: $radiusMobile;
  padding-bottom: 41.6666667%;
  background-color: $grey-lighten-1;
  overflow: hidden;

  img {
    position: absolute;
    height: 100%;
    position: absolute;
    top: 0; /* 補上：固定在頂部 */
    left: 0; /* 補上：固定在左側 */
    width: 100%; /* 補上：強制填滿寬度 */
    height: 100%; /* 你的原本設定：填滿高度 */
    object-fit: contain;
  }
}

::v-deep {
  .float-btn {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    margin-top: 20px;
  }

  @media screen and (max-width: 600px) {
    .location-content {
      max-height: 42px;
      overflow: hidden;
    }
  }

  .campaign-content-frame {
    ol,
    ul {
      margin: 0;
      padding: 0;
      counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
        list-9;
    }

    ol,
    ul {
      padding-left: 1.5em;
    }

    ol > li,
    ul > li {
      list-style-type: none;
    }

    ul > li::before {
      content: "\2022";
    }

    ul[data-checked="false"],
    ul[data-checked="true"] {
      pointer-events: none;
    }

    ul[data-checked="false"] > li *,
    ul[data-checked="true"] > li * {
      pointer-events: all;
    }

    ul[data-checked="false"] > li::before,
    ul[data-checked="true"] > li::before {
      color: #777;
      cursor: pointer;
      pointer-events: all;
    }

    ul[data-checked="true"] > li::before {
      content: "\2611";
    }

    ul[data-checked="false"] > li::before {
      content: "\2610";
    }

    li::before {
      display: inline-block;
      white-space: nowrap;
      width: 1.2em;
    }

    li:not(.ql-direction-rtl)::before {
      margin-left: -1.5em;
      margin-right: 0.3em;
      text-align: center;
    }

    li.ql-direction-rtl::before {
      margin-left: 0.3em;
      margin-right: -1.5em;
    }

    ol > li:not(.ql-direction-rtl),
    ul li:not(.ql-direction-rtl) {
      padding-left: 1.5em;
    }

    ol > li.ql-direction-rtl,
    ul > li.ql-direction-rtl {
      padding-right: 1.5em;
    }

    ol > li {
      counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
        list-9;
      counter-increment: list-0;
    }

    ol > li:before {
      content: counter(list-0, decimal) ". ";
    }

    ol > li.ql-indent-1 {
      counter-increment: list-1;
    }

    ol > li.ql-indent-1:before {
      content: counter(list-1, lower-alpha) ". ";
    }

    ol > li.ql-indent-1 {
      counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    }

    ol > li.ql-indent-2 {
      counter-increment: list-2;
    }

    ol > li.ql-indent-2:before {
      content: counter(list-2, lower-roman) ". ";
    }

    ol > li.ql-indent-2 {
      counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    }

    ol > li.ql-indent-3 {
      counter-increment: list-3;
    }

    ol > li.ql-indent-3:before {
      content: counter(list-3, decimal) ". ";
    }

    ol > li.ql-indent-3 {
      counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
    }

    ol > li.ql-indent-4 {
      counter-increment: list-4;
    }

    ol > li.ql-indent-4:before {
      content: counter(list-4, lower-alpha) ". ";
    }

    ol > li.ql-indent-4 {
      counter-reset: list-5 list-6 list-7 list-8 list-9;
    }

    ol > li.ql-indent-5 {
      counter-increment: list-5;
    }

    ol > li.ql-indent-5:before {
      content: counter(list-5, lower-roman) ". ";
    }

    ol > li.ql-indent-5 {
      counter-reset: list-6 list-7 list-8 list-9;
    }

    ol > li.ql-indent-6 {
      counter-increment: list-6;
    }

    ol > li.ql-indent-6:before {
      content: counter(list-6, decimal) ". ";
    }

    ol > li.ql-indent-6 {
      counter-reset: list-7 list-8 list-9;
    }

    ol > li.ql-indent-7 {
      counter-increment: list-7;
    }

    ol > li.ql-indent-7:before {
      content: counter(list-7, lower-alpha) ". ";
    }

    ol > li.ql-indent-7 {
      counter-reset: list-8 list-9;
    }

    ol > li.ql-indent-8 {
      counter-increment: list-8;
    }

    ol > li.ql-indent-8:before {
      content: counter(list-8, lower-roman) ". ";
    }

    ol > li.ql-indent-8 {
      counter-reset: list-9;
    }

    ol > li.ql-indent-9 {
      counter-increment: list-9;
    }

    ol > li.ql-indent-9:before {
      content: counter(list-9, decimal) ". ";
    }

    .ql-indent-1:not(.ql-direction-rtl) {
      padding-left: 3em;
    }

    li.ql-indent-1:not(.ql-direction-rtl) {
      padding-left: 4.5em;
    }

    .ql-indent-1.ql-direction-rtl.ql-align-right {
      padding-right: 3em;
    }

    li.ql-indent-1.ql-direction-rtl.ql-align-right {
      padding-right: 4.5em;
    }

    .ql-indent-2:not(.ql-direction-rtl) {
      padding-left: 6em;
    }

    li.ql-indent-2:not(.ql-direction-rtl) {
      padding-left: 7.5em;
    }

    .ql-indent-2.ql-direction-rtl.ql-align-right {
      padding-right: 6em;
    }

    li.ql-indent-2.ql-direction-rtl.ql-align-right {
      padding-right: 7.5em;
    }

    .ql-indent-3:not(.ql-direction-rtl) {
      padding-left: 9em;
    }

    li.ql-indent-3:not(.ql-direction-rtl) {
      padding-left: 10.5em;
    }

    .ql-indent-3.ql-direction-rtl.ql-align-right {
      padding-right: 9em;
    }

    li.ql-indent-3.ql-direction-rtl.ql-align-right {
      padding-right: 10.5em;
    }

    .ql-indent-4:not(.ql-direction-rtl) {
      padding-left: 12em;
    }

    li.ql-indent-4:not(.ql-direction-rtl) {
      padding-left: 13.5em;
    }

    .ql-indent-4.ql-direction-rtl.ql-align-right {
      padding-right: 12em;
    }

    li.ql-indent-4.ql-direction-rtl.ql-align-right {
      padding-right: 13.5em;
    }

    .ql-indent-5:not(.ql-direction-rtl) {
      padding-left: 15em;
    }

    li.ql-indent-5:not(.ql-direction-rtl) {
      padding-left: 16.5em;
    }

    .ql-indent-5.ql-direction-rtl.ql-align-right {
      padding-right: 15em;
    }

    li.ql-indent-5.ql-direction-rtl.ql-align-right {
      padding-right: 16.5em;
    }

    .ql-indent-6:not(.ql-direction-rtl) {
      padding-left: 18em;
    }

    li.ql-indent-6:not(.ql-direction-rtl) {
      padding-left: 19.5em;
    }

    .ql-indent-6.ql-direction-rtl.ql-align-right {
      padding-right: 18em;
    }

    li.ql-indent-6.ql-direction-rtl.ql-align-right {
      padding-right: 19.5em;
    }

    .ql-indent-7:not(.ql-direction-rtl) {
      padding-left: 21em;
    }

    li.ql-indent-7:not(.ql-direction-rtl) {
      padding-left: 22.5em;
    }

    .ql-indent-7.ql-direction-rtl.ql-align-right {
      padding-right: 21em;
    }

    li.ql-indent-7.ql-direction-rtl.ql-align-right {
      padding-right: 22.5em;
    }

    .ql-indent-8:not(.ql-direction-rtl) {
      padding-left: 24em;
    }

    li.ql-indent-8:not(.ql-direction-rtl) {
      padding-left: 25.5em;
    }

    .ql-indent-8.ql-direction-rtl.ql-align-right {
      padding-right: 24em;
    }

    li.ql-indent-8.ql-direction-rtl.ql-align-right {
      padding-right: 25.5em;
    }

    .ql-indent-9:not(.ql-direction-rtl) {
      padding-left: 27em;
    }

    li.ql-indent-9:not(.ql-direction-rtl) {
      padding-left: 28.5em;
    }

    .ql-indent-9.ql-direction-rtl.ql-align-right {
      padding-right: 27em;
    }

    li.ql-indent-9.ql-direction-rtl.ql-align-right {
      padding-right: 28.5em;
    }
  }
}

.rounded-rwd {
  border-radius: $radiusMobile;

  @media screen and (min-width: 769px) {
    border-radius: $radiusDesktop;
  }
}

.titleBanner {
  max-height: 5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.domain,
.tag {
  height: 21px;
}

h1 {
  min-height: 52px;
}

.titleBar {
  position: fixed;
  width: 100%;
  z-index: 1;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.wordBreakKeepAll {
  word-break: keep-all;
}

.wordBreakAll {
  word-break: break-all;
}

@media screen and (max-width: 600px) {
  .sesstion-item {
    border: solid 2px $grey-lighten-1;
    border-radius: $radiusMobile;
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 16px;
  }
  #buyTicket {
    min-height: 400px;
  }
}

.campainTabs {
  height: 48px;
  position: sticky;
  z-index: 1;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
}

::v-deep .v-tabs-slider-wrapper {
  height: 4px !important;
  background: $gradient !important;

  .v-tabs-slider {
    background: $gradient;
  }
}

::v-deep .campaign-content-frame {
  max-width: 970px;
  margin: 25px auto;
  font-weight: 500;

  iframe {
    width: 100%;
    height: calc(100vw * 0.5);
    max-height: 543px;
  }

  img {
    width: auto;
    max-width: 100%;
  }

  li {
    line-height: 2;
  }
}
</style>
